export const communications = (state) => state.communications
export const totalCommunications = (state) => state.totalCommunications
export const selectAllField = (state) => state.selectAllField
export const selectedCommunications = (state) => state.selectedCommunications